import { z } from "zod/v4";

/**
 * The set of report types currently exposed via the client API.
 *
 * Adding a new report type is a small change here plus a `ReportTypeResources`
 * instantiation in {@link ../cdk/realm-reports-stack.ts}; everything keyed by
 * `{type}` in the client-API URL space (the list / item / snapshot-url routes)
 * automatically picks up the new value via this enum's wire shape.
 *
 * Why the literal union (not `z.string()`): the `{type}` segment is a hard
 * enumeration on the server side — every plugin that can ever appear here is
 * registered in code, not data. Validating early at the URL boundary means a
 * typo is rejected with a 400 before any DDB query runs, and the decoded type
 * narrows safely into handler dependencies. The wire form is the same string
 * the generator stamps into `ReportEntity.type`, so no codec is needed.
 */
export const ReportType = z.enum(["wastesense", "roadsense"]);
export type ReportType = z.infer<typeof ReportType>;

/**
 * Path schema for resources templated as `"{type}/..."`.
 *
 * The single-key shape matches the resource template's placeholder set, so the
 * client API URL builder (`expandEndpoint` → `interpolateResource`) and the
 * Lambda router both see the same `type` parameter without any extra mapping.
 */
export const TypePath = z.object({ type: ReportType });
export type TypePath = z.output<typeof TypePath>;
